import React, { useState, useEffect, forwardRef } from 'react';
import Grid from '@material-ui/core/Grid'
import FormDatePicker from '../../../components/DatePicker';
import FormControl from '@material-ui/core/FormControl';
import { lightTheme } from "../../../SharedComponents/SharedComponentStyles";
import { ThemeProvider, Button } from "@material-ui/core";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import MaterialTable from "material-table";
import Select from '@material-ui/core/Select';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import axios from 'axios'
import Alert from '@material-ui/lab/Alert';
import Tooltip from '@material-ui/core/Tooltip';
import { useSelector, useDispatch } from "react-redux";


const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

const api = axios.create({
    baseURL: `MasterDetails`
})
const apirpt = axios.create({
    baseURL: 'WorkCenter'
})

function WorkCenterLossesReport(props) {
    const [openLoader, setopenLoader] = useState(false);
    //for alert
    const [open, setopen] = useState(false);
    const [openAlert, setopenAlert] = useState("");
    const [openClassName, setopenClassName] = useState("");
    const [openType, setopenType] = useState("");
    //const [alertsuccess, setalertsuccess] = useState("Success");
    const [alerterror, setalerterror] = useState("Alert");
    //const [alertsuccessclass, setalertsuccessclass] = useState("bg-light-green clr-white");
    const [alerterrorclass, setalerterrorclass] = useState("bg-red clr-white");

    const token = useSelector((state) => state.saveAzureTokenReducer.token);
    const userDetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData);
    const bearerToken = useSelector(
    (state) => state.saveBearerTokenReducer.bearerToken);
    const uId = useSelector((state) => state.saveUIDReducer.uid);

    function showMsg(popen, popenAlert, popenClassName, popenType) {
        setopen(popen);
        setopenAlert(popenAlert);
        setopenClassName(popenClassName);
        setopenType(popenType);
    }

    function handleClose() {
        setopen(false);
    }
    const [data, setData] = useState([]); //table data
    const [mrpController, setMrpController] = React.useState('');
    const [mrp, setmrp] = useState([]);
    const [mrplookup, setmrplookup] = useState([]);
    //const [wageGroup, setWageGroup] = React.useState('');
    //const [wage, setwage] = useState([]);
    const [typeOfMachine, setTypeOfMachine] = React.useState([]);
    const [typeOfMach, settypeOfMach] = React.useState('');

    const [workctr, setWorkctr] = React.useState([]);
    const [workcenter, setworkcenter] = React.useState('');
    const [fromdate, setFromdate] = useState(null);
    const [todate, setTodate] = useState(null);

    function dateChangeEvent(dateValue, label) {
        if (label === "From Date") {
            if (todate !== null) {
                if ((Date.parse(dateValue) > Date.parse(todate))) {
                    showMsg(true, "From date should be less than To date", alerterrorclass, alerterror);
                    setFromdate(null);
                }
                else {
                    setFromdate(dateValue);
                }
            }
            else {
                setFromdate(dateValue);
            }
        }
        else if (label === "To Date") {
            if ((Date.parse(fromdate) > Date.parse(dateValue))) {
                showMsg(true, "From date should be greater than To date", alerterrorclass, alerterror);
                setTodate(null);
            }
            else {
                setTodate(dateValue);
            }
        }
    }

    const handleChange = (event) => {
        setMrpController(event.target.value);
    };
    const handleChangeTypeOfMachine = (event) => {
        settypeOfMach(event.target.value);
    };
    const handleChangeWorkctr = (event) => {
        setworkcenter(event.target.value);
    };
    const [WorkerShift, setWorkerShift] = useState([]);
    const SearchTable = (event) => {
        if (fromdate != null && todate != null) {
            GetFilterSlipSummary();
            getMRP();
            GetWorkCenter();
            GetMachineType();
        }
        else {
            getMRP();
            GetWorkCenter();
            GetMachineType();
            showMsg(true, "Please select From Date and To Date for fetching report details!", alerterrorclass, alerterror);
        }

    };
    //for error handling
    const [iserror, setIserror] = useState(false)
    const [errorMessages, setErrorMessages] = useState([])
    var columns = [
        //{ title: "Date", field: "viewEntryDate" },
        { title: 'Entry Date', field: 'entryDate', type: 'date', dateSetting: { locale: "en-GB" }, },
        { title: "MRP Controller", field: "mrpcontrollerId", lookup: mrplookup },
        { title: "Shift", field: "workerShiftId", lookup: WorkerShift },
        { title: "WorkCenter", field: "workCenter" },
        { title: "AMH(Worker Loaded)", field: "amh" },
        { title: "Tool Breakdown", field: "toolBreakdown" },
        { title: "Machine Breakdown", field: "machineBreakdown" },
        { title: "Power Failure", field: "powerFailure" },
        { title: "No Operator", field: "noOperator" },
        { title: "No Raw Material", field: "noRawMaterial" },
        { title: "No Tool", field: "noTool" },
        { title: "No Order", field: "noOrder" },
        { title: "Other Losses", field: "otherLosses" },
        { title: "Planned Loss", field: "plannedLosses" },
        { title: "Total Loss", field: "totalLosses" },
        { title: "Available machine Hours", field: "totalAmh" },
    ]

    function getShift() {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        api.get('/getAllEmployeeShift/',{
            headers: headers
        })
            .then(res => {
                var obj = res.data.reduce(function (acc, cur, i) {
                    acc[cur.shiftId] = cur.shiftName;
                    return acc;
                }, {});
         
                setWorkerShift(obj);
            })
            .catch(error => {
                console.log("Error in hitting api at page load. Shift")
            })
    }
    function getMRP() {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        api.get('/getTblMstMrpcontroller/',{
            headers: headers
        })
            .then(res => {

                setmrp(res.data);
                var obj = res.data.reduce(function (acc, cur, i) {
                    acc[cur.mrpcontrollerId] = cur.mrpcontroller;
                    return acc;
                }, {});
                setmrplookup(obj);
            })
            .catch(error => {
                console.log("Error in hitting api at page load.")
            })
    }

    function GetFilterSlipSummary() {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        setopenLoader(true);
        getShift();

        let slipDet = {
            FromDate: fromdate,
            ToDate: todate,
            MrpcontrollerId: Number(mrpController),
            WorkCenter: Number(workcenter),
            WorkingMethodID: Number(typeOfMach)
        }
        apirpt.post("/getWorkCenterLossesReport/", slipDet,{
            headers: headers
        })
            .then(res => {
                setData(res.data);
                setopenLoader(false);
            })
            .catch(error => {
                console.log("Error in hitting api : WorkCenterLosses")
            })
    }
    function GetMachineType() {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        api.get('/getTblMstWorkingMethod/',{
            headers: headers
        })
            .then(res => {
                setTypeOfMachine(res.data);
            })
            .catch(error => {
                console.log("Error in hitting api at page load. : WageGroup")
            })
    }
    function GetWorkCenter() {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        api.get('/getTblMstWorkCenter/',{
            headers: headers
        })
            .then(res => {
                setWorkctr(res.data);
            })
            .catch(error => {
                console.log("Error in hitting api at page load. : WageGroup")
            })
    }
    useEffect(() => {
        getMRP();
        GetMachineType();
        GetWorkCenter();
       
    }, [])


    return (
        <ThemeProvider theme={lightTheme}>
            <Grid container spacing={1} className="reports d-flex jc-space-bt mt-1">
                <Grid item xs={12} sm={2} className="d-flex Width-100">
                    <FormControl className="width-100 mt-01">
                        <FormDatePicker
                            id="FromDate"
                            placeholder="From Date"
                            label="From Date"
                            value={fromdate}
                            onChange={dateChangeEvent}
                            disablefuturedate={true}
                            required={true}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={2} className="d-flex Width-100">
                    <FormControl className="width-100 mt-01">
                        <FormDatePicker
                            id="ToDate"
                            placeholder="To Date"
                            label="To Date"
                            value={todate}
                            onChange={dateChangeEvent}
                            disablefuturedate={true}
                            required={true}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={2} className="d-flex Width-100">
                    <FormControl className="width-100">
                        <InputLabel id="demo-simple-select-label">MRP Controller</InputLabel>
                        <Select
                            labelId="mrp-controller-label"
                            id="mrp-controller"
                            value={mrpController}
                            onChange={handleChange}
                        >
                            <MenuItem value="">
                                <em>None</em>
                            </MenuItem>
                            {
                                mrp.map((h, i) =>
                                    (<MenuItem key={i} value={h.mrpcontrollerId}>{h.mrpcontroller}</MenuItem>))
                            }
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={2} className="d-flex Width-100">
                    <FormControl className="width-100">
                        <InputLabel id="demo-simple-select-label">Type Of Machine</InputLabel>
                        <Select
                            labelId="type-of-machine"
                            id="typeOfMachine"
                            value={typeOfMach}
                            onChange={handleChangeTypeOfMachine}
                        >
                            <MenuItem value="">
                                <em>None</em>
                            </MenuItem>
                            {
                                typeOfMachine.map((h, i) =>
                                    (<MenuItem key={i} value={h.workingMethodId}>{h.workingMethod}</MenuItem>))
                            }
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={2} className="d-flex Width-100">
                    <FormControl className="width-100 mb-1">
                        <InputLabel id="demo-simple-select-label">Work center</InputLabel>
                        <Select
                            labelId="work-ctr"
                            id="workctr"
                            value={workcenter}
                            onChange={handleChangeWorkctr}
                        >
                            <MenuItem value="">
                                <em>None</em>
                            </MenuItem>
                            {
                                workctr.map((h, i) =>
                                    (<MenuItem key={h.workCenterId} value={h.workCenterId}>{h.workCenterCode + "-" + h.workCenter}</MenuItem>))
                            }
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={1} className="d-flex jc-flex-end">
                    <Tooltip title="Filter Data" placement="right" arrow onClick={SearchTable}>
                        <Button className="download-icon" startIcon={<FilterList />}>
                        </Button>
                    </Tooltip>
                </Grid>
                <Grid item xs={12}>
                    {iserror &&
                        <Alert severity="error">
                            {errorMessages.map((msg, i) => {
                                return <div key={i}>{msg}</div>
                            })}
                        </Alert>
                    }
                    <MaterialTable
                        title="Work  Center Wise Losses Report"
                        columns={columns}
                        data={data}
                        icons={tableIcons}
                        options={{
                            pageSizeOptions: [30, 40, 50],    // rows selection options
                            pageSize: 30,
                            exportAllData: true,
                            exportButton: true,
                            maxBodyHeight: 600,
                        }}
                        editable={{

                        }}
                    />
                </Grid>
            </Grid>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="draggable-dialog-title"
                id="templateUploadSuccess">
                <DialogTitle className={openClassName} style={{ cursor: 'move' }} id="draggable-dialog-title">
                    {openType}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText className="clr-black">
                        {openAlert}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" autoFocus onClick={handleClose} className="ns-btn-secondary-light">
                        <span className="f-16 fw-bold">OK</span>
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={openLoader}
                //onClose={handleClose}
                aria-labelledby="draggable-dialog-title"
                id="templateUploadSuccess"
                PaperProps={{
                    style: {
                        backgroundColor: "transparent",
                        boxShadow: "none",
                        borderColor: "transparent"
                    },
                }}>
                <DialogContent>
                    <CircularProgress />
                </DialogContent>
            </Dialog>
        </ThemeProvider>
    );
}

export default WorkCenterLossesReport;